module.exports = __webpack_public_path__ + "img/finalize-penalty-card.69b0ea5a.png";